<template>

  <div>
    <!--    Guest needs to login-->
    <div v-if="!$page.props.user">
      <guest-view :room-name="room.room_name"></guest-view>
    </div>
    <WaitingList :users="waitingUsers" :room="room" v-if="waitingUsers.length > 0 && !room.is_public"/>
    <div v-if="showLobby" class="h-full p-40">
      <div class=" text-center">
        <div class="flex justify-center py-2">
          <slot name="logo"></slot>
        </div>
        <div class="flex justify-center py-2">
          <span
              class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
            {{ room.is_public ? 'Public Room' : 'Team Room' }}
          </span>
        </div>
      </div>
      <!--    Public View -->
      <template v-if="$page.props.user && room.is_public">
        <div class=" text-center">
          <div class="font-semibold block text-center text-4xl mb-4">
            <span class="inline-block text-bold text-blue-400">{{ room.room_name }}</span> is on fire 🔥
          </div>
          <loading-animation></loading-animation>
        </div>
        <div class="text-center p-5">
          <button type="button"
                  @click="showLobby=false;"
                  class="font-bold inline-flex items-center px-6 py-3 border border-transparent text-base rounded-full
                  text-indigo-700 bg-indigo-200 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Enter in
          </button>
        </div>
      </template>

      <!--    Team Member Approval View -->
      <template
          v-else-if="$page.props.user && !room.is_public &&  $page.props.user.current_team_id !== room.team_id">

        <div class=" text-center mb-20">
          <div class="font-semibold block text-center text-4xl mb-4">
            Waiting for team manager to approve your access request 👀
          </div>
          <loading-animation></loading-animation>
        </div>
        <slot name="team"></slot>
      </template>
      <!--    Team member can access-->
      <template
          v-else-if="$page.props.user && !room.is_public && $page.props.user.current_team_id === room.team_id">
        <div class=" text-center">

          <div class="font-semibold block text-center text-4xl mb-4">
            <span class="inline-block text-bold text-blue-400">{{ room.room_name }}</span> is on fire 🔥
          </div>
          <loading-animation></loading-animation>
        </div>
        <div class="text-center p-5">
          <button type="button"
                  @click="showLobby=false;"
                  class="font-bold inline-flex items-center px-6 py-3 border border-transparent text-base rounded-full
                  text-indigo-700 bg-indigo-200 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Enter in
          </button>
        </div>
      </template>
      <div class="flex justify-center p-5">
        <slot name="players"></slot>
      </div>
      <div v-if="!($page.props.user && !room.is_public &&  $page.props.user.current_team_id !== room.team_id)">
        <slot name="custom"></slot>
      </div>
    </div>
    <div v-else>
      <slot name="room"></slot>
    </div>

  </div>

</template>

<script>

import GuestView from "@/Pages/Lobby/Components/GuestView";
import LoadingAnimation from "@/Components/LoadingAnimation/LoadingAnimation";
import WaitingList from "./Components/WaitingList";
import {onMounted, ref, watchEffect} from "vue";
import {message} from "ant-design-vue";
import emitter from 'tiny-emitter/instance'


export default {
  name: 'Lobby',
  components: {
    emitter,
    WaitingList,
    LoadingAnimation,
    GuestView
  },
  props: {
    room: {
      required: true,
      type: Object,
      default: {
        'room_key': '',
        'room_id': '',
        'room_name': '',
        'team_owner_name': '',
        'team_id': '',
        'room_type': '',
        'team_owner_id': '',
        'is_public': false,
      }
    },
    showLobby: {
      required: false,
      type: Boolean,
      default: true
    },
  },
  created() {
  },
  setup(props) {
    const waitingUsers = ref([]);

    const fetchLobbyData = async () => {

      await axios.get(route("lobby.get.data"))
          .then((response) => {
            waitingUsers.value = response.data.data.waiting_list; // 只用判定length就足够
          })
          .catch((error) => {
            console.log(error);
            message.error('Please sign in first.', 5);
          }); // 多用chain
    }
    onMounted(async () => {
      if(!props.room.is_public){
        await fetchLobbyData(); // 不需要watch，直接await
        emitter.on('VueLobbyEvent', async () => {
          await fetchLobbyData();
        });
      }
    })

    return {
      waitingUsers // current user 没有任何必要
    };

  },
  data() {
    return {};
  },
  mounted() {
  },

  methods: {},
};
</script>